import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles.css'

const Root = __CAMPAIGN_DM_QA__ && window.location.pathname === '/dm-qa'
  ? React.lazy(() => import('./CampaignDmQa.jsx')) : App

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('Service worker registration failed:', error)
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <React.Suspense fallback={<p>載入中…</p>}><Root /></React.Suspense>
  </React.StrictMode>,
)
